import { render, staticRenderFns } from "./ChartingWorkspaceResultsColumn.vue?vue&type=template&id=0844de60&scoped=true&"
import script from "./ChartingWorkspaceResultsColumn.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspaceResultsColumn.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspaceResultsColumn.vue?vue&type=style&index=0&id=0844de60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844de60",
  null
  
)

export default component.exports